export default function initPageToc(target) {
  var nav = target.querySelector("[data-page-toc]");
  if (!nav) return;

  var links = nav.querySelectorAll('a[href^="#"]');
  if (!links.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          links.forEach(function (l) {
            l.classList.remove("active");
          });
          var link = nav.querySelector('a[href="#' + entry.target.id + '"]');
          if (link) link.classList.add("active");
        }
      });
    },
    { rootMargin: "0px 0px -80% 0px" },
  );

  links.forEach(function (link) {
    var id = link.getAttribute("href").slice(1);
    var el = document.getElementById(id);
    if (el) {
      observer.observe(el);
      link.addEventListener("click", function (e) {
        e.preventDefault();
        el.scrollIntoView({ behavior: "smooth" });
        history.replaceState(null, null, "#" + id);
      });
    }
  });
}
